import $http from '@/module/http';

export default {
  strict: true,
  namespaced: true,
  state: {
    planDetail: {},
    featureOptions: []
  },
  mutations: {
    setPlanDetail(state, payload) {
      state.planDetail = payload;
    },
    setFeatureOptions(state, payload) {
      state.featureOptions = payload;
    }
  },
  actions: {
    getPlanDetail({ commit }, payload) {
      return $http
        .get(`plans/${payload.planId}/`)
        .then((res) => {
          commit('setPlanDetail', res);
          return res;
        })
        .catch((e) => {
          return Promise.reject(e.detail);
        });
    },
    getFeatureOptions({ commit }, payload) {
      let queryObj = {
        product__isnull: 'True',
        type: 'select'
      };
      if (payload && typeof payload === 'object') {
        Object.keys(payload).forEach((key) => {
          if (payload[key] !== undefined && payload[key] !== null && payload[key] !== '') {
            queryObj[key] = payload[key];
          }
        });
      }
      const q = Object.entries(queryObj)
        .map(([k, v]) => `${k}=${v}`)
        .join(',');

      return $http
        .get('product_features/', {
          params: {
            page_size: 9999,
            q
          }
        })
        .then((res) => {
          const sortedFeatureOptions =
            res.results.length > 0
              ? res.results.sort((a, b) => {
                  const nameA = a.name || '';
                  const nameB = b.name || '';
                  return nameA.localeCompare(nameB);
                })
              : [];
          commit('setFeatureOptions', sortedFeatureOptions);
          return sortedFeatureOptions;
        })
        .catch((e) => {
          return Promise.reject(e);
        });
    }
  }
};
